/**
 * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
 * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
 * Таким образом можно управлять всеми конфигами в этом файле
 */
itsoftApp.createModule("slidersSettings", function () {
    // Локальные переменные
    const module = this;

    const Settings = {
        global: {
            slidesPerView: "auto",
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            freeModeMomentum: false,
            speed: 500,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                }
            }
        },

        cycle: {
            slidesPerView: "auto",
            simulateTouch: false,
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            followFinger: false,
            watchOverflow: true,
            autoHeight: true,
            a11y: {
                firstSlideMessage: "",
                lastSlideMessage: ""
            },
            centeredSlides: true,
            // centeredSlidesBounds: true,
            // slidesOffsetBefore: 140,
            freeModeMomentum: false,
            speed: 500,
            // autoplay: {
            //     disableOnInteraction: false,
            //     waitForTransition: false,
            //     pauseOnMouseEnter: true,
            //     delay: 8000
            // },
            spaceBetween: 207,
            on: {
                init: function () {
                    const swiper = this;
                    const swiperContainer = swiper.el;
                    const slider = swiperContainer.closest('.js-slider');
                    const sliderName = swiperContainer.getAttribute("data-slider-name");
                    itsoftApp.modules.scrollActions.callback(slider);
                    
                    swiper.params.custom = {
                        swiperContainer: swiperContainer,
                        slider: slider,
                        sliderName: sliderName,
                        pointWrapperElements: slider.querySelectorAll(".js-point-wrapper"),
                        pointElements: slider.querySelectorAll(".js-point")
                    }

                    const customParams = swiper.params.custom;

                    if (sliderName) {
                        Swiper.initedSliders[sliderName] = this;
                    }
                },

                slideChange: function () {
                    const timeline = document.querySelector(".js-timeline");
                    const timelineWrapper = document.querySelector(".js-timeline-wrapper");
                    const activeIndex = Swiper.initedSliders["cycle"].activeIndex
                    const activeSlideNumber = activeIndex + 1;
                    const pointWrapperEls = Swiper.initedSliders["cycle"].params.custom.pointWrapperElements;
                    const pointEls = Swiper.initedSliders["cycle"].params.custom.pointElements;

                    let mm = gsap.matchMedia();

                    mm.add("(min-width: 1024px)", () => {
                        const numberToTranslate = {
                            item1: 0,
                            item2: -17.2,
                            item3: -34.2,
                            item4: -51
                        }
                        
                        window.gsap && gsap.to(timeline, {
                            translateX: numberToTranslate['item' + activeSlideNumber] + 'vw'
                        });

                        Array.prototype.forEach.call(pointWrapperEls, function (pointWrapper, index) {
                            if (index < activeIndex) {
                                gsap.to(pointWrapper, {
                                    autoAlpha: 0,
                                    duration: 0.3
                                });
                            } else {
                                gsap.to(pointWrapper, {
                                    autoAlpha: 1,
                                    duration: 0.3
                                });
                            }

                            if (index == activeIndex) {
                                gsap.to(pointEls[index], {
                                    autoAlpha: 0,
                                    delay: 0.3,
                                    duration: 0.3
                                });

                                pointWrapper.classList.add("js-active");
                            } else if (index > activeIndex) {
                                gsap.to(pointEls[index], {
                                    autoAlpha: 1,
                                    delay: 0.1,
                                    duration: 0.3
                                });
                            } else if (index < activeIndex) {
                                if (pointWrapper.classList.contains("js-active")) {
                                    pointWrapper.classList.remove("js-active");
                                }
                            }
                        });
                    });

                    mm.add("(max-width: 1023px)", () => {
                        const numberToTranslate = {
                            item1: 0,
                            item2: -27.8,
                            item3: -68.2,
                            item4: -110.7
                        }

                        const timeline = document.querySelector(".js-timeline");
                        
                        window.gsap && gsap.to(timeline, {
                            translateX: numberToTranslate['item' + activeSlideNumber] + 'vw'
                        });

                        Array.prototype.forEach.call(pointWrapperEls, function (pointWrapper, index) {
                            if (index < activeIndex) {
                                gsap.to(pointWrapper, {
                                    autoAlpha: 0,
                                    duration: 0.3
                                });
                            } else {
                                gsap.to(pointWrapper, {
                                    autoAlpha: 1,
                                    duration: 0.3
                                });
                            }

                            if (index == activeIndex) {
                                gsap.to(pointEls[index], {
                                    autoAlpha: 0,
                                    delay: 0.3,
                                    duration: 0.3
                                });

                                pointWrapper.classList.add("js-active");
                            } else if (index > activeIndex) {
                                gsap.to(pointEls[index], {
                                    autoAlpha: 1,
                                    delay: 0.1,
                                    duration: 0.3
                                });
                            } else if (index < activeIndex) {
                                if (pointWrapper.classList.contains("js-active")) {
                                    pointWrapper.classList.remove("js-active");
                                }
                            }

                            console.log(activeIndex, ' activeIndex')
                            console.log(index, ' index')
                            if (activeIndex == 3) {
                                gsap.to(timelineWrapper, {
                                    width: '89.8vw'
                                });
                            } else {
                                gsap.to(timelineWrapper, {
                                    width: '95.3vw'
                                });
                            }
                        });
                    });
                    // if (activeSlideNumber)
                }
            }
        }
    };

    const getSettings = function (slidersSettingsKey) {
        return Settings[slidersSettingsKey];
    };

    module.getSettings = getSettings;
});